import { render } from "./App.vue?vue&type=template&id=44f2b8f6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=44f2b8f6&lang=scss"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__